module.exports = "/assets/data/3fa63017abc2e7c9a715bdea9edd35cc-B10.data.json";